<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\vi\newManual\searchCourseManual-1.png" alt="" /></div>
                <div>
                    <p>① Nhấn vào khóa học muốn học được hiển thị trên trang chủ hoặc tìm kiếm bằng từ khóa liên quan trong ô tìm kiếm.</p>
                </div>
                <div><img src="/static\images\vi\newManual\searchCourseManual-2.png" alt="" /></div>
                <div>
                    <p>② Nhấn vào khóa học muốn học, sẽ di chuyển đến màn hình chi tiết khóa học.</p>
                    <p>③ Từ lần login sau, những khóa học đã tham gia sẽ được hiển thị trong Khóa học của tôi theo thứ tự ngày tham gia.</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div><p>① Nhấn icon [Tìm kiếm] ở phía trên màn hình sẽ xuất hiện ô tìm kiếm.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\search_1.png" alt="" /></div>
                <div><p>② Nhập tên khóa học mà bạn cần tìm kiếm và nhấn vào nút [Tìm kiếm].</p></div>
                <div><img src="/static\images\vi\newManual\mobile\search_2.png" alt="" /></div>
                <div><p>③ Hiển thị ra những khóa học trùng với tên mà bạn đã nhập.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\search_3.png" alt="" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/vi/searchCourse_manual.vue